import { IJsonQuery } from '../json_query';
import { EFacility } from '../json_query/types';

export function facilitiesFromJsonQuery(jsonQuery: IJsonQuery): EFacility[] {
  return (Object.keys(EFacility) as (keyof typeof EFacility)[]).reduce((previousValue, currentValue) => {
    const facility = EFacility[currentValue];
    if (jsonQuery[facility] !== undefined) {
      previousValue.push(facility);
    }

    return previousValue;
  }, [] as EFacility[]);
}
